import React from "react";
import "./Courses.css";

const CourseCard = ({
  course,
  onClick,
  extraClass,
  status,
  Icon,  
  is_open_for_everyone,
}) => {
  const layoutClass =
    status === "in_progress" ? "column-layout" : "row-layout";

  const is_open = is_open_for_everyone === false ? "close_for_everyone" : "";
  console.error("is_open: ", is_open)
  return (
    <div
      className={`course-card ${layoutClass} ${extraClass} ${is_open}`}
      onClick={onClick}
    >
      {status === "in_progress" ? (
        <>
          <h2 className="course-title">{course.front_name}</h2>
          <div className="spinner-wrapper">
            <div className="spinner" />
          </div>
        </>
      ) : (
        <>
          {Icon && (
            <div className="course-icon-wrapper">
              <Icon className="course-icon" />
            </div>
          )}
          <h2 className="course-title">{course.front_name}</h2>
        </>
      )}
    </div>
  );
};

export default CourseCard;
